module.exports = __webpack_public_path__ + "static/media/logo-1.a6ee1fb7.png";